var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-2 text-center border-0 rounded-3 black agent-count bg-background width-5-rem"},[_vm._v(" "+_vm._s(_vm.amountOfResults)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }